import { render, staticRenderFns } from "./OVDetails.vue?vue&type=template&id=ffaf32de&scoped=true&lang=pug"
import script from "./OVDetails.vue?vue&type=script&lang=js"
export * from "./OVDetails.vue?vue&type=script&lang=js"
import style0 from "./OVDetails.vue?vue&type=style&index=0&id=ffaf32de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaf32de",
  null
  
)

export default component.exports